import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/SchoolProgram/2024/orientation/1.jpg';
// import p2 from 'assests/Photos/SchoolProgram/2024/orientation/2.jpg';
// import p3 from 'assests/Photos/SchoolProgram/2024/orientation/3.jpg';
// import p4 from 'assests/Photos/SchoolProgram/2024/orientation/4.jpg';
// import p5 from 'assests/Photos/SchoolProgram/2024/orientation/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2024/orientation/6.jpg';


// import p5 from 'assests/Photos/SchoolProgram/2023/Valediction_ceremony/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const TeachersDay2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/4.webp`;
    const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/5.webp`;
    const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/6.webp`;
    const p7  = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/7.webp`;
    const p8  = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/8.webp`;
    const p9  = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/9.webp`;
    const p10 = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/10.webp`;
    const p11 = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/11.webp`;
    const p12 = `${config.base_image_url_2025}/home/events-activities/school-programs/Teachersday/12.webp`;

   
    const photos = [
         {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
},
{
  src: p10,
  source: p10,
  rows: 1,
  cols: 1,
},
{
  src: p11,
  source: p11,
  rows: 1,
  cols: 1,
},
{
  src: p12,
  source: p12,
  rows: 1,
  cols: 1,
} 

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                               CELEBRATIONS – TEACHER’S DAY, ONAM, EID-E-MILAD 
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                              Date: 4 September 2025
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                On Thursday, 4 September 2025, the school came alive with cultural vibrancy, as festive 
                                celebrations took place across different classes. Our Pre-Primary students, along with 
                                those from Classes 3 to 5, joyously celebrated Onam, the traditional harvest festival of 
                                Kerala. The highlight of the celebration was a delightful dance drama that beautifully 
                                narrated the legend of King Mahabali, celebrating values of unity, prosperity and cultural 
                                pride.
                                <br></br>
                                Simultaneously, Classes 1 and 2 observed Teachers’ Day with heartfelt enthusiasm. The 
                                young learners expressed their gratitude and affection through melodious songs, lovingly 
                                handmade cards and cheerful performances. To add to the joyous spirit, Classes 9 – 12 
                                organised fun games for the teachers, filling the room with laughter as students clapped 
                                and cheered with excitement.  
                                <br></br>
                                In a wonderful gesture of inclusivity, Classes 6 to 8 observed Id-e-Milad, commemorating 
                                the birth of Prophet Muhammad. Students shared thoughtful presentations and recited 
                                meaningful messages centred around peace, compassion and kindness.
                               <br></br>
                                Later in the day, the teachers came together to enjoy a traditional Onam delicacies, 
                                further enhancing the festive spirit. The gathering was made even more memorable with 
                                a few teachers singing melodious songs, conducting an engaging quiz and sharing 
                                thoughtful messages that reflected the essence of the day. 
                              <br></br>
                                The entire celebration was a true embodiment of unity in diversity — a heart-warming 
                                tribute to learning, appreciation and cultural harmony. 
                               <br></br>
                                </Typography>
                            </Box>
                            {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ The strength of a democracy lies in the ability of its citizens to question, engage, and actively participate in shaping its future.”

                                <br />
                            </Typography> */}

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default TeachersDay2025;